export enum ContentTypes {
    json = 'application/json'
}
